import { lazy, Suspense } from 'react';
import { useTenant } from './Common/Contexts/TenantContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Template_1 = lazy(() => import('./Templates/Template_1'));
const Template_2 = lazy(() => import('./Templates/Template_2'));
const Template_3 = lazy(() => import('./Templates/Template_3'));

const templateMap = {
  Template_1,
  Template_2,
  Template_3
};

function App() {
  const { tenantData, loading } = useTenant();

  if (loading) return <div>Loading...</div>;

  const ref = tenantData?.templateReference || 'Template_1';
  const ActiveTemplate = templateMap[ref] || Template_1;

  return (
    <>
      <Suspense fallback={<div>Loading template...</div>}>
        <ActiveTemplate />
      </Suspense>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;